import styled from 'styled-components';

export const NotFoundWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 2rem;
  padding: 4rem 1rem;
  font-weight: 500;
  min-height: 50vh;
`;

export const NotFoundCode = styled.div`
  font-size: 7rem;
  font-weight: 800;
  color: ${(props) => props.theme.primaryColor};
  line-height: 1;
  margin-bottom: 0.5rem;

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    font-size: 5rem;
  }
`;

export const NotFoundTitle = styled.h1`
  font-size: ${(props) => props.theme.fontSizeTitle};
  color: ${(props) => props.theme.titleColor};
  margin: 0 0 1rem;

  @media only screen and (max-width: ${(props) => props.theme.breakpointSm}) {
    font-size: ${(props) => props.theme.fontSizeMobileTitle};
  }
`;

export const NotFoundBody = styled.p`
  font-size: ${(props) => props.theme.fontSizeBase};
  color: ${(props) => props.theme.secondaryColor};
  text-align: center;
  margin: 0 0 2rem;
  max-width: 420px;
`;

export const HomeButton = styled.button`
  background-color: ${(props) => props.theme.primaryColor};
  color: #fff;
  border: none;
  border-radius: ${(props) => props.theme.borderRadius};
  padding: 0.65rem 1.75rem;
  font-size: ${(props) => props.theme.fontSizeBase};
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.85;
  }
`;
